import {useContext, useEffect, useState, useCallback, useRef} from 'react';
import _ from 'underscore';
import {
    Button, Dialog, DialogContent, DialogTitle, DialogActions, CircularProgress,
    Container, Grid, Paper,Table,TableBody, TableCell, TableContainer, TableHead,
    TableRow, TextField
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import {useParams, useHistory} from 'react-router-dom';
import {DataGrid} from '@mui/x-data-grid';
import {Controller, useForm} from 'react-hook-form';
import {DocumentService, DocumentTemplateService} from '../../../services';
import ValidationError from "../../shared/ValidationError";
import {NotificationContext} from "../../../components/NotificationContext";
import Prompt from "../../../customUtil/Prompt";
import { CurrentUserContext } from '../../../components/CurrentUserContext';

const availableColumns = [
    {
        field: 'title', headerName: 'Document Name', width: 430,
    }
]

const TemplateForm = () => {
    const methods = useForm();
    const [data, setData] = useState({});
    const [documentTemplateMembers, setDocumentTemplateMembers] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [availableDocuments, setAvailableDocuments] = useState([]);
    const [availableSelection, setAvailableSelection] = useState([]);
    const [isReady, setIsReady] = useState(false);
    const {showMessage, showError} = useContext(NotificationContext);
    const [open, setOpen] = useState(false);
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [openInfo, setOpenInfo] = useState(false);
    const {id} = useParams();
    const history = useHistory();
    const [block, setBlock] = useState(false);  
    const refSubmitButtom = useRef();
    const [showProgress, setShowProgress] = useState(false);
    const [triggerExit, setTriggerExit] = useState({
        onOk: false,
        path: ""
      });
      const [isVisibleDialog, setVisibleDialog] = useState(false);
      const {rights} = useContext(CurrentUserContext);

    const handleGoToIntendedPage = useCallback(
        (location) => history.push(location),
        [history]
      );
      const handleClose = () => {
        setOpen(false);
        setOpenConfirmation(false);
        setOpenInfo(false);
    }

    const removeDocumentSet = () => {
        setShowProgress(true);
        DocumentTemplateService.delete(data.id).then((response) => {                
                showMessage('Successfully Deleted');
                history.push("/templates/document-sets");   
                setShowProgress(false);                                
            }).catch((response) => {
            handleClose();
            setOpenInfo(true);
            setShowProgress(false);                                

        });
    }

      useEffect(() => {
       
        const unblock = history.block((location) => {
          if (location.pathname !== `/gas/account-statements/${id}`) {
            if(block){
                setVisibleDialog(true);   
                setTriggerExit({...triggerExit, path: location.pathname});
            }else{
                setVisibleDialog(false);   
                setTriggerExit({onOk: true, path: location.pathname});
            }
                           
              }
         
          if (triggerExit.onOk) {
            return true;
          }
          return false;
        });
        if (triggerExit.onOk) {
            handleGoToIntendedPage(triggerExit.path);
          }
        return () => {
          unblock();
        };
      }, [history, triggerExit.onOk, triggerExit.path, block]);

    const refreshAvailableDocuments = () => {
        if (documents.length === 0) {
            return;
        }
        if (documentTemplateMembers.length === 0) {
            setAvailableDocuments(documents);
        }
        var xx = documents.filter((i) => {
            return !(documentTemplateMembers.find((item) => item.document.id === i.id))
        });
        setAvailableDocuments(xx);
    }

    useEffect(() => {
        DocumentService.getAll().then((response) => {
            setDocuments(response.data);
            refreshAvailableDocuments();
        });

        if (id !== "new") {
            DocumentTemplateService.getById(id).then((response) => {
                setData(response.data);
                setDocumentTemplateMembers(response.data.documentTemplateMembers);
                setIsReady(true);
            });
        } else {
            setData({templateName: '', countryDefaults: {}, documentTemplateMembers: []});
            setDocumentTemplateMembers([]);
            setIsReady(true);
        }
        // eslint-disable-next-line
    }, [id]);

    useEffect(() => {
        refreshAvailableDocuments();
        // eslint-disable-next-line
    }, [documentTemplateMembers, documents]);

    const {handleSubmit, control, ref, errors} = methods;

    const onSubmit = d => {
        setBlock(false);
        setVisibleDialog(false);
        const request = {
            ...data, ...d,
            documentTemplateMembers: documentTemplateMembers.map(i => i.id < 0 ? {...i, id: undefined} : i)
        };
        if (data.id) {
            DocumentTemplateService.update(request)
                .then((response) => {
                    setData(response.data);
                    showMessage('Document set updated.')
                }).catch((response) => {
                showError(response.message)
            });
        } else {
            DocumentTemplateService
                .create(request)
                .then((response) => {
                    setData(response.data);
                    showMessage('Document set Created.');
                });
        }
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        setTimeout(() => {
            setIsReady(true);
            history.push('/templates/document-sets')
        }, 100)   
    };

    const onDefaultOriginalsChange = (value, row) => {
        const members = documentTemplateMembers.slice();
        let theRow = _.find(members, {id: row.id});
        theRow.defaultOriginals = value;
        setDocumentTemplateMembers(members);
    }

    const onDefaultCopiesChange = (value, row) => {
        const members = documentTemplateMembers.slice();
        let theRow = _.find(members, {id: row.id});
        theRow.defaultCopies = value;
        setDocumentTemplateMembers(members);
    }

    const onDefaultOrderChange = (value, row) => {
        const members = documentTemplateMembers.slice();
        let theRow = _.find(members, {id: row.id});
        theRow.defaultOrder = value;
        setDocumentTemplateMembers(members);
    }

    const addSelection = () => {

        if (availableSelection.length > 0) {
            const newDocumentTemplateMembers = [...documentTemplateMembers];
             let m = {};
            for (let entry of Object.values(availableSelection)) {
                for(let field of Object.values(availableDocuments)){
                    if(field.id === entry){
                      m = field;
                    }
                }
                const member = {
                    id: -(newDocumentTemplateMembers.length),
                    document: m,
                    defaultOriginals: 1,
                    defaultCopies: 1,
                    defaultOrder: newDocumentTemplateMembers.length + 1
                }
                
                newDocumentTemplateMembers.push(member);
                
            }
            setAvailableSelection([]);
            setDocumentTemplateMembers(newDocumentTemplateMembers);
        }
    };

    const selectAvailableDocuments = (rows) => {
        setAvailableSelection(rows);
    }

    const removeRow = (row) => {
        setDocumentTemplateMembers(documentTemplateMembers.filter(obj => obj.id !== row.id))
    };

    if (!isReady) {
        return (
            <CircularProgress/>
        );
    }
    const triggerSubmit = () => {
        refSubmitButtom?.current?.click();
      };     
   
      const onSave = (event) => {
          triggerSubmit();
          setBlock(false);
          setVisibleDialog(false);
      }
  
      const checkModified = (event) => {
          if(event.type ===  "change"){
              setBlock(true);
                 }
              }
    return (
        <Container>
            <header>
                <h1>Document Sets</h1>
            </header>
            <form style={{textAlign: 'left'}} onSubmit={handleSubmit(onSubmit)} onChange={event => {checkModified(event)}}>
            <Prompt
               visible={isVisibleDialog}
               onClose={() => setVisibleDialog(false)}
               onOk={() => {
               setTriggerExit({...triggerExit, onOk: true});
               setVisibleDialog(false);
               setBlock(false);
            }}
               onSave={onSave}
            />
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        Document sets is a group of documents that will appear together on most shipping instructions.
                    </Grid>
                    <Grid item xs={12}> <br /></Grid>
                    <Grid item xs={6}>
                        <Controller
                            name="templateName"
                            control={control}
                            as={TextField}
                            fullWidth
                            label="Document Set Name"
                            color="primary"
                            rules={{required: 'Document Set Name is required.'}}
                            variant="outlined"
                            defaultValue={data.templateName}
                        />
                        <ValidationError error={errors.templateName}/>
                    </Grid>
                    <Grid item xs={6}>

                    </Grid>
                    <Grid item xs={7}>
                        <h3>Selected Documents</h3>
                        <TableContainer component={Paper}>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Document</TableCell>
                                        <TableCell style={{maxWidth: '40px'}} align="right"># of Originals</TableCell>
                                        <TableCell style={{maxWidth: '40px'}} align="right"># of Copies</TableCell>
                                        <TableCell style={{maxWidth: '40px'}} align="right">Order</TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {documentTemplateMembers.map((row) => (
                                        <TableRow key={row.document.title}>
                                            <TableCell style={{padding: 0, paddingLeft: 10, margin: 0}} component="th"
                                                       scope="row">
                                                {row.document.title}
                                            </TableCell>
                                            <TableCell style={{padding: 0, margin: 0}} align="right">
                                                <TextField style={{maxWidth: '100px'}} type="number" ref={ref}
                                                           size="small" variant="outlined"
                                                           value={row.defaultOriginals}
                                                           onChange={(e) => onDefaultOriginalsChange(e.target.value, row)}/>
                                            </TableCell>
                                            <TableCell style={{padding: 0, margin: 0}} align="right">
                                                <TextField style={{maxWidth: '100px'}} type="number" ref={ref}
                                                           size="small" variant="outlined"
                                                           value={row.defaultCopies}
                                                           onChange={(e) => onDefaultCopiesChange(e.target.value, row)}/>
                                            </TableCell>
                                            <TableCell style={{padding: 0, margin: 0}} align="right">
                                                <TextField style={{maxWidth: '100px'}} type="number" ref={ref}
                                                           size="small" variant="outlined"
                                                           value={row.defaultOrder}
                                                           onChange={(e) => onDefaultOrderChange(e.target.value, row)}/>
                                            </TableCell>
                                            <TableCell style={{padding: 0, margin: 0, paddingLeft: 5}}>
                                                <IconButton size="small" aria-label="delete"
                                                            onClick={() => removeRow(row)}>
                                                    <DeleteIcon color="error"/>
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                    </Grid>
                    <Grid item xs={1}>
                        <Grid container spacing={0}
                              align="center"
                              justifyContent="center"
                              direction="column">
                            <Grid item xs={12}>
                                <h3> &nbsp; </h3>
                                <Button variant="outlined" color="primary"> <span
                                    onClick={addSelection}>add</span></Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={3}>
                        <h3>Available Documents</h3>
                        <DataGrid
                            rowHeight={35}
                            autoHeight={true}
                            rows={availableDocuments}
                            checkboxSelection={true}
                            onRowSelectionModelChange={(newSelection) => {
                                selectAvailableDocuments(newSelection);
                            }}
                            columns={availableColumns} pageSize={10}
                        />
                    </Grid>
                    <Grid></Grid>
                    <br />
                    <Grid item xs={9}>
                            <Button variant="contained" color="primary" type="submit">Submit</Button>
                        </Grid>
                        {(rights.includes("ROLE_SI_ADMIN") && id !== 'new') &&    
                        <Grid item xs={3}>
                            <Button variant="contained" color="danger" onClick={() => setOpenConfirmation(true)}>Remove statement</Button>
                        </Grid>
                     }
                </Grid>
                <Dialog open={openConfirmation} onClose={handleClose} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Confirm Delete</DialogTitle>
                    <DialogContent>                      
                          Are you sure you want to delete this document set?                                           
                    </DialogContent>
                    <DialogActions>
                        {showProgress &&  <CircularProgress style={{width: "12px", height: "10px"}}/>}                       
                    <Button onClick={removeDocumentSet} color="primary" disabled={showProgress}>
                            yes
                        </Button>
                        <Button onClick={handleClose} color="primary">
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={openInfo} onClose={handleClose} aria-labelledby="form-dialog-title">                   
                    <DialogContent>                       
                          This document-set can not be deleted because it is already in use.                                             
                    </DialogContent>
                    <DialogActions>                    
                        <Button onClick={handleClose} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog> 
            </form>
        </Container>
    );
};

export default TemplateForm;
